import { render, staticRenderFns } from "./Preorders.vue?vue&type=template&id=444a98bc&scoped=true&"
import script from "./Preorders.vue?vue&type=script&lang=js&"
export * from "./Preorders.vue?vue&type=script&lang=js&"
import style0 from "./Preorders.vue?vue&type=style&index=0&id=444a98bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444a98bc",
  null
  
)

export default component.exports